import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { useNavigate } from 'react-router-dom'

import { LandingMessage, LandingMessageType } from '../../../lib/landing-message'
import { currentCompany, Company } from '../../../lib/current-company'
import { LandingPageLayout } from '../../../lib/landing-page-layout'
import Text from '../../../ui/Text'
import { theme } from '../../../lib/theme'
import useText from '../../hooks/useText'

export type ResetPasswordRequestSuccessPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function ResetPasswordRequestSuccessPage({
    className,
    style,
}: ResetPasswordRequestSuccessPageProps): React.ReactElement {
    const text = useText()
    const navigate = useNavigate()

    return (
        <LandingPageLayout
            className={cn(className)}
            style={style}
            background={currentCompany === Company.FORTUM ? theme.greenBackground : theme.whiteBackground}
            hideLanguageSelect
        >
            <LandingMessage
                linkText={text('lblReturnToSignIn')}
                onClick={() => {
                    navigate('/login', { replace: true })
                }}
                type={LandingMessageType.SUCCESS}
            >
                <div data-testid="message">
                    {currentCompany === Company.FORTUM ? (
                        <Text code="msgResetPasswordSent" />
                    ) : (
                        <Text code="msgResetPasswordLinkSent" />
                    )}
                </div>
            </LandingMessage>
        </LandingPageLayout>
    )
}
